import { useEffect, useState } from "react";

// Minimal history-based router. Firebase hosting rewrites every path to
// index.html, so /product resolves to this bundle in production too.
export type Route = "home" | "product";

export const PRODUCT_PATH = "/product";

export function routeFor(pathname: string): Route {
  return pathname.replace(/\/+$/, "") === PRODUCT_PATH ? "product" : "home";
}

export function navigate(path: string) {
  const [pathname, hash] = path.split("#");
  const samePage = window.location.pathname === pathname;
  if (!samePage) {
    window.history.pushState({}, "", path);
    window.dispatchEvent(new PopStateEvent("popstate"));
  } else if (hash) {
    window.history.replaceState({}, "", path);
  }
  if (!hash) {
    window.scrollTo({ top: 0 });
    return;
  }
  // The target page may not be mounted yet; scroll on the next frame.
  window.scrollTo({ top: 0 });
  window.requestAnimationFrame(() => {
    document.getElementById(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
  });
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() => routeFor(window.location.pathname));
  useEffect(() => {
    const onPop = () => setRoute(routeFor(window.location.pathname));
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);
  return route;
}

// Click handler for in-app anchors: keeps cmd/ctrl-click and middle-click
// working as native links while pushing history for plain clicks.
export function onLinkClick(path: string) {
  return (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    navigate(path);
  };
}
